<template>
  <div class="online-experience-facial">
        <b-container fluid >
            <b-row v-if="!validcode">
                <b-col cols="12" class="mycontainer-main m-borders">
                    <div class="row h-100">
                        <div class="col-sm-12 align-self-center text-center">
                            <div>
                                <div id="bar" class="bar">
                                </div>
                                <h2 class="fade-in" >Welcome to the Beaute Integrale Facial Experience</h2>
                                <p class="fade-in" >Enter Your Purchase Code Below</p>
                                <b-form>
                                    <input type="text"  style="width: 300px; height:50px;" class="text-center" placeholder="enter code here" v-model="code">
                                    <br>
                                    <b-button squared style="background-color: black;" class="main-button fade-in mt-3" v-on:click="checkCode">start facial</b-button>                                
                                </b-form>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row v-else>
            <div class='col-sm-12'>
                <div class="card-style">
                <b-progress :value="progress" squared variant="dark"></b-progress>
                </div>
                <div class="row mt-5">
                    <div class='col-sm-12'>
                        <b-card v-if="current_step==1" class="card-style" title="prepare">
                        <b-card-text>Something for first step.</b-card-text>
                        <b-button squared style="background-color: black;" class="float-right"  @click="onClickNext">Next</b-button>
                        </b-card>
                        <b-card v-if="current_step==2" class="card-style" title="STEP2">
                        <b-card-text>Do something for second step.</b-card-text>
                        <b-button class="float-left" variant="secondary" @click="onClickBack">Back</b-button>
                        <b-button class="float-right" variant="primary" @click="onClickNext">Next</b-button>
                        </b-card>
                        <b-card v-if="current_step==3" class="card-style" title="STEP3">
                        <b-card-text>For furthermore in 3rd step.</b-card-text>
                        <b-button class="float-left" variant="secondary" @click="onClickBack">Back</b-button>
                        <b-button class="float-right" variant="primary" @click="onClickNext">Next</b-button>
                        </b-card>
                        <b-card v-if="current_step==4" class="card-style" title="STEP4">
                        <b-card-text>Will soon finish.</b-card-text>
                        <b-button class="float-left" variant="secondary" @click="onClickBack">Back</b-button>
                        <b-button class="float-right" variant="primary" @click="onClickNext">Next</b-button>
                        </b-card>
                        <b-card v-if="current_step==5" class="card-style" title="STEP5">
                        <b-card-text>Finished!</b-card-text>
                        <b-button class="float-left" variant="secondary" @click="onClickBack">Back</b-button>
                        <b-button class="float-center" variant="success" @click="onClickFirst">Back to first</b-button>
                        </b-card>
                    </div>
                </div>
            </div>
            </b-row>       

        </b-container>
  </div>
</template>

<script>
export default {
  name: 'online-experience-facial',
  data () {
    return {
      code: '',
      validcode: false,
      current_step: 1,
      max_step: 10
    }
  },
  methods: {
    checkCode () {
          this.validcode = true
      },
    onClickNext: function() {
      this.current_step++;
    },
    onClickBack: function() {
      this.current_step--;
    },
    onClickFirst: function() {
      this.current_step = 1;
    }
  },
   computed: {
    progress: function() {
      return Math.round(100 / this.max_step) * this.current_step;
    }
  },
}
</script>

<style scoped>
.mycontainer-main {
    height:  calc(80vh - 10vh);
}
.bar {
  animation-duration: 3s;
  animation-name: slidein;
  background-color: black;
  height: 25px;
  margin-bottom: 25px;
  margin-left: 25vw;
  margin-right: 25vw;
}
.animate-left {
   animation-duration: 3s;
    animation-name: slidein;   
}

@keyframes slidein {
  from {
    margin-right: 100%;
  }

  to {
    margin-right: 25%;

  }
}
</style>


// WEBPACK FOOTER //
// src/pages/OnlineExperienceFacial.vue